<template>
  <confirmation-list :manifests="manifests" />
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmationList from '../../../components/_ConfirmationList'

export default {
  name: 'DriverManifestConfirmationList',
  components: {
    ConfirmationList
  },
  mixins: [],
  props: {},
  data() {
    return {
      systemTime: null,
      manifests: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.systemTime = this.$dayjs().format("YYYY/MM/DD HH:mm")
    const params = this.$route.query
    this.fetchManifests({ params: params }).then((content) => {
      this.manifests = content.manifests
    })
  },
  methods: {
    ...mapActions('DriverManifestConfirmationList', {
      fetchManifests: 'index',
    }),
  }
}
</script>
